/**
 * drawer-context.js
 */

import React from 'react';


export const TrackingDrawerContext = React.createContext();


export const TrackingDrawerProvider = (props) => {
  const [state, setState] = React.useState({
    isDrawerLoading: false,
    isDrawerExpanded: true,
    drawerExpansionHeight: 0,
  });


  // sets drawer loading state
  const setIsDrawerLoading = React.useCallback((isDrawerLoading) => {
    setState(p => ({
      ...p,
      isDrawerLoading
    }));
  }, []);


  // sets bottom drawer expansion state.
  const setIsDrawerExpanded = React.useCallback((isDrawerExpanded) => {
    setState(p => ({
      ...p,
      isDrawerExpanded
    }));
  }, []);


  // sets drawer expansion height
  const setDrawerExpansionHeight = React.useCallback((drawerExpansionHeight) => {
    setState(p => ({
      ...p,
      drawerExpansionHeight
    }));
  }, []);



  const value = React.useMemo(() => ({
    ...state,
    setIsDrawerLoading,
    setIsDrawerExpanded,
    setDrawerExpansionHeight
  }), [
    state,
    setIsDrawerLoading,
    setIsDrawerExpanded,
    setDrawerExpansionHeight
  ]);



  return (<>
    <TrackingDrawerContext.Provider 
      value={value}
      children={props.children}
    />
  </>);

}